export default __webpack_public_path__ + "static/media/Announcments.6087b835.png";